//
//
import {
  call,
  put,
  takeEvery,
  take,
  select,
  takeLatest,
} from "redux-saga/effects"

import {
  CONTRIBUYENTES_GET_LISTA,
  CONTRIBUYENTES_GET_OPTIONS,
  CONTRIBUYENTES_GET_BUSQUEDA,
  CONTRIBUYENTES_POST_CREATE,
  CONTRIBUYENTES_PUT_UPDATE,
  CONTRIBUYENTES_DEL_DELETE,
} from "./actionTypes"

import {
  setContribuyentesResponseParametros,
  getContribuyentesListaSuccess,
  getContribuyentesListaFail,
  getContribuyentesOptionsSuccess,
  getContribuyentesOptionsFail,
  getContribuyentesBusquedaSuccess,
  getContribuyentesBusquedaFail,
  postContribuyentesCreateSuccess,
  postContribuyentesCreateFail,
  putContribuyentesUpdateSuccess,
  putContribuyentesUpdateFail,
  delContribuyentesDeleteSuccess,
  delContribuyentesDeleteFail,
} from "./actions"

import {
  get_From_ContribuyentesController,
  post_To_ContribuyentesController,
  put_To_ContribuyentesController,
  del_From_ContribuyentesController,
} from "../../helpers/campusvirtualbackend_helper"
import { json } from "react-router-dom"

function* fetchContribuyentesLista({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_ContribuyentesController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getContribuyentesListaFail(response.Mensaje_Detalle))
    } else {
      yield put(getContribuyentesListaSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getContribuyentesListaFail(error))
  }
}
function* fetchContribuyentesOptions({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_ContribuyentesController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getContribuyentesOptionsFail(response.Mensaje_Detalle))
    } else {
      yield put(getContribuyentesOptionsSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getContribuyentesOptionsFail(error))
  }
}
function* fetchContribuyentesBusqueda({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_ContribuyentesController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getContribuyentesBusquedaFail(response.Mensaje_Detalle))
    } else {
      yield put(getContribuyentesBusquedaSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getContribuyentesBusquedaFail(error))
  }
}
function* fetchContribuyentesCreate({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      post_To_ContribuyentesController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postContribuyentesCreateFail(response.Mensaje_Detalle))
    } else {
      yield put(postContribuyentesCreateSuccess(response.Datos))
      yield put(setContribuyentesResponseParametros(response.Parametros))
    }
  } catch (error) {
    yield put(postContribuyentesCreateFail(error))
  }
}
function* fetchContribuyentesUpdate({ payload: { jsonparameters } }) {
  try {
    const response = yield call(put_To_ContribuyentesController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(putContribuyentesUpdateFail(response.Mensaje_Detalle))
    } else {
      yield put(putContribuyentesUpdateSuccess(response.Datos))
    }
  } catch (error) {
    yield put(putContribuyentesUpdateFail(error))
  }
}
function* fetchContribuyentesDelete({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      del_From_ContribuyentesController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield del(delContribuyentesDeleteFail(response.Mensaje_Detalle))
    } else {
      yield del(delContribuyentesDeleteSuccess(response.Datos))
    }
  } catch (error) {
    yield del(delContribuyentesDeleteFail(error))
  }
}

function* ContribuyentesSaga() {
  yield takeLatest(CONTRIBUYENTES_GET_LISTA, fetchContribuyentesLista)
  yield takeLatest(CONTRIBUYENTES_GET_OPTIONS, fetchContribuyentesOptions)
  yield takeLatest(CONTRIBUYENTES_GET_BUSQUEDA, fetchContribuyentesBusqueda)
  yield takeLatest(CONTRIBUYENTES_POST_CREATE, fetchContribuyentesCreate)
  yield takeLatest(CONTRIBUYENTES_PUT_UPDATE, fetchContribuyentesUpdate)
  yield takeLatest(CONTRIBUYENTES_DEL_DELETE, fetchContribuyentesDelete)
}

export default ContribuyentesSaga
